export default {
    indexTiltes: {
        original: {
            title: '优秀原创内容',
            desc:
                '趣头条平台吸纳了一大批个⼈⼤V、权威媒体、企业组织等类型的自媒体创作方入驻<br>为优质内容创建提供了良好的生态土壤',
        },
        honor: {
            title: '获得行业荣誉',
            desc:
                '短短18个月，凭借出色的内容创新与阅读体验<br>成为资讯APP新锐独角兽并获得多项殊荣',
        },
        event: {
            title: '趣头条大事件',
            desc:
                '趣头条从2016年至2018年发展迅速<br>其中经历了几次大的变革以及获得很多行业荣誉',
        },
        news: {
            title: '媒体报道',
            desc:
                '趣头条在企业快速发展中<br>多次获得行业内各类权威性知名媒体报道',
        },
        cooperate: {
            title: '合作媒体客户',
            desc:
                '趣头条与国内知名媒体强强联合<br>提供给用户更丰富更有趣有料的内容',
        },
    },
    honorList: [
        {
            pic: '//static-oss.qutoutiao.net/qutoutiao/index/img/honor_5.jpg',
            text: '123公益爱心<br>企业奖',
        },
        {
            pic: '//static-oss.qutoutiao.net/qutoutiao/index/img/honor_6.jpg',
            text: '2018第六届TopDigital<br>创新奖金奖',
        },
        {
            pic: '//static-oss.qutoutiao.net/qutoutiao/index/img/honor_7.jpg',
            text: '2018金瑞奖最具成长力<br>产品奖',
        },
        {
            pic: '//static-oss.qutoutiao.net/qutoutiao/index/img/honor_8.jpg',
            text: '2018年度中国公益<br>企业奖',
        },
    ],
    eventList: [
        {
            title: '2018.3 完成B轮融资',
            content: '完成超2亿美元B轮融资，投后估值超16 亿美金',
        },
        {
            title: '2017.12 猎豹年度app排行榜',
            content:
                '新闻类APP排行第三，仅次于今日头条和腾讯（猎豹2017中国年度APP排行榜）',
        },
        {
            title: '2017.6.8 趣头条上线一周年',
            content:
                '趣头条上线一周年，在 OPPO应用商店排行第4、Vivo应用商店排行第5。App Store资讯类排行免费应用中一度排行NO.4',
        },
        {
            title: '2017.3 趣头条2.0版本上线',
            content:
                '趣头条2.0版本上线后，用户及数据量大幅增长，趣头条在CheethLab资讯类应用排行榜上排名第11。',
        },
        {
            title: '2017年初 获得行业奖励',
            content:
                '猎豹、WiFi 万能钥匙等第三方季度、年度报告均将趣头条列为增长最快的新闻资讯类应用。',
        },
        {
            title: '2016.6.8 趣头条1.0上线',
            content:
                '趣头条1.0正式上线，倚靠差异化定位、独特的获客机制、快速发展的自媒体内容平台、以及基于深度学习的推荐算法。',
        },
    ],
    mediaList: [
        {
            name: 'people',
            link: 'http://www.people.com.cn/',
            mobileLink: 'http://m.people.cn',
        },
        {
            name: 'youth',
            link: 'http://www.youth.cn/',
            mobileLink: '',
        },
        {
            name: 'chinanews',
            link: 'http://www.chinanews.com/',
            mobileLink: 'http://www.chinanews.com/wap/',
        },
        {
            name: 'hexun',
            link: 'http://www.hexun.com/',
            mobileLink: 'http://m.hexun.com/',
        },
        {
            name: 'thepaper',
            link: 'https://www.thepaper.cn/',
            mobileLink: '',
        },
        {
            name: 'jcrb',
            link: 'http://www.jcrb.com/',
            mobileLink: '',
        },
        {
            name: 'hxnews',
            link: 'http://www.hxnews.com/',
            mobileLink: '',
        },
        {
            name: 'huanqiu',
            link: 'http://www.huanqiu.com/',
            mobileLink: '',
        },
    ],
};
